(function () {
  var ARROW_SVG_LEFT = '<svg viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M12.5 15 7.5 10l5-5"/></svg>';
  var ARROW_SVG_RIGHT = '<svg viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M7.5 15l5-5-5-5"/></svg>';

  // The storefront /products/x.js "images" list uses protocol-relative URLs (//cdn...)
  // while "media[].src" uses absolute URLs (https://cdn...) for the same file. Normalize
  // before comparing so the two lists can be matched up reliably.
  function normalizeUrl(url) {
    return (url || '').replace(/^https?:/, '').split('?')[0];
  }

  // Shopify generates each color's photo set as duplicate-filename uploads with an extra
  // "_<uuid>" segment appended for every color after the first. Splitting the URL on "_"
  // gives a stable, per-color signature (token count) so we can group a product's images
  // by which color they actually belong to, without knowing the color name.
  function colorSignature(url) {
    return normalizeUrl(url).split('_').length;
  }

  function groupImagesByColor(images) {
    var groups = {};
    images.forEach(function (src) {
      var sig = colorSignature(src);
      (groups[sig] = groups[sig] || []).push(src);
    });
    return groups;
  }

  function updateActive(gallery) {
    var track = gallery.querySelector('.cn-swipe-track');
    var slides = gallery.querySelectorAll('.cn-swipe-slide');
    if (!track || slides.length < 2) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    if (index < 0) index = 0;
    if (index > slides.length - 1) index = slides.length - 1;
    var dots = gallery.querySelectorAll('.cn-swipe-dot');
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    var prev = gallery.querySelector('.cn-swipe-arrow--prev');
    var next = gallery.querySelector('.cn-swipe-arrow--next');
    if (prev) prev.hidden = index === 0;
    if (next) next.hidden = index === slides.length - 1;
  }

  function wireInteractivity(gallery) {
    if (gallery.dataset.cnWired) return;
    gallery.dataset.cnWired = '1';
    var track = gallery.querySelector('.cn-swipe-track');
    if (!track) return;

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { updateActive(gallery); raf = null; });
    }, { passive: true });

    gallery.querySelectorAll('.cn-swipe-arrow').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dir = btn.classList.contains('cn-swipe-arrow--next') ? 1 : -1;
        track.scrollBy({ left: track.clientWidth * dir, behavior: 'smooth' });
      });
    });

    // Distinguish a tap (navigate) from a drag-swipe (don't navigate) for pointer/mouse users.
    var startX = 0, startY = 0, moved = false;
    var link = gallery.dataset.cnLink;
    track.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; moved = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true;
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); return; }
      if (e.target.closest('.cn-swipe-arrow')) return;
      if (link) { window.location.href = link; }
    });

    updateActive(gallery);
  }

  function setGallerySlides(gallery, images, alt) {
    var track = gallery.querySelector('.cn-swipe-track');
    track.innerHTML = '';
    images.forEach(function (src) {
      var slide = document.createElement('div');
      slide.className = 'cn-swipe-slide';
      var img = document.createElement('img');
      img.src = src;
      img.loading = 'lazy';
      img.alt = alt || '';
      slide.appendChild(img);
      track.appendChild(slide);
    });
    track.scrollTo({ left: 0 });

    var existingDots = gallery.querySelector('.cn-swipe-dots');
    if (existingDots) existingDots.remove();
    if (images.length > 1) {
      var dots = document.createElement('div');
      dots.className = 'cn-swipe-dots';
      images.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'cn-swipe-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(dot);
      });
      gallery.appendChild(dots);
    }
    var prev = gallery.querySelector('.cn-swipe-arrow--prev');
    var next = gallery.querySelector('.cn-swipe-arrow--next');
    if (prev) prev.hidden = true;
    if (next) next.hidden = images.length < 2;
  }

  function buildGalleryMarkup(images, alt) {
    var wrap = document.createElement('div');
    wrap.className = 'cn-swipe-gallery cn-swipe-gallery--native';
    var track = document.createElement('div');
    track.className = 'cn-swipe-track';
    wrap.appendChild(track);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'cn-swipe-arrow cn-swipe-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = ARROW_SVG_LEFT;
    prev.hidden = true;
    wrap.appendChild(prev);

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'cn-swipe-arrow cn-swipe-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = ARROW_SVG_RIGHT;
    wrap.appendChild(next);

    setGallerySlides(wrap, images, alt);
    return wrap;
  }

  function wireSwatchSync(card, gallery, mediaMap, groups, title) {
    var inputs = card.querySelectorAll('input[data-option-media-id]');
    if (!inputs.length) return;
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var mediaId = input.getAttribute('data-option-media-id');
        var src = mediaMap[mediaId];
        if (!src) return;
        var sig = colorSignature(src);
        var matched = groups[sig];
        var normalizedSrc = normalizeUrl(src);
        var images = matched && matched.length ? matched.slice(0, 5) : [src];
        // Keep the swatch's own image first even if grouping didn't catch it.
        if (normalizeUrl(images[0]) !== normalizedSrc) {
          images = [src].concat(images.filter(function (i) { return normalizeUrl(i) !== normalizedSrc; }));
        } else {
          images[0] = src;
        }
        setGallerySlides(gallery, images, title);
      });
    });
  }

  function patchNativeCard(card) {
    if (card.dataset.cnGalleryDone) return;
    card.dataset.cnGalleryDone = '1';

    var container = card.querySelector('[ref="cardGallery"], .card-gallery');
    if (!container) return;
    var linkEl = card.querySelector('a[href*="/products/"]');
    if (!linkEl) return;
    var href = linkEl.getAttribute('href');
    var handle = href.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    var currentImg = container.querySelector('img');
    var currentSrc = currentImg ? currentImg.src : null;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.images || data.images.length < 2) return;
        var groups = groupImagesByColor(data.images);
        var initialImages;
        if (currentSrc) {
          var sig = colorSignature(currentSrc);
          initialImages = groups[sig];
        }
        if (!initialImages || !initialImages.length) initialImages = data.images;
        initialImages = initialImages.slice(0, 5);

        var gallery = buildGalleryMarkup(initialImages, data.title);
        gallery.dataset.cnLink = href;
        // Clearing the gallery container also wipes Shopify's native quick-add button,
        // since it renders as a sibling inside the same [ref="cardGallery"] wrapper
        // (right after the native slideshow). Detach it first and re-attach it after
        // our markup so the bag icon keeps working on collection/related-product cards.
        var quickAdd = container.querySelector('quick-add-component');
        container.innerHTML = '';
        container.appendChild(gallery);
        if (quickAdd) container.appendChild(quickAdd);
        wireInteractivity(gallery);

        var mediaMap = {};
        (data.media || []).forEach(function (m) { mediaMap[m.id] = m.src; });
        wireSwatchSync(card, gallery, mediaMap, groups, data.title);
      })
      .catch(function () {});
  }

  var nativeObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) patchNativeCard(entry.target);
    });
  }, { rootMargin: '300px' });

  function scanNativeCards() {
    document.querySelectorAll('product-card:not([data-cn-gallery-done])').forEach(function (card) {
      nativeObserver.observe(card);
    });
  }

  function scanBuiltGalleries() {
    document.querySelectorAll('.cn-swipe-gallery:not([data-cn-wired])').forEach(wireInteractivity);
  }

  function scanAll() {
    scanNativeCards();
    scanBuiltGalleries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  var bodyObserver = new MutationObserver(function () { scanAll(); });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
